import produce from 'immer';
export var getInitialState = function () { return ({
    status_loading: false,
    status_error: false,
    status: { devplan_status: true, consumption_status: true, payment: true },
}); };
function appDevPlanStatusReducer(currentState, action) {
    if (currentState === void 0) { currentState = getInitialState(); }
    return produce(currentState, function (state) {
        switch (action.type) {
            case 'GET_STATUS_REQUEST':
                state.status_loading = true;
                state.status_error = false;
                break;
            case 'GET_STATUS_SUCCESS':
                state.status_loading = false;
                state.status_error = false;
                state.status = action.status || {
                    devplan_status: false,
                    consumption_status: false,
                    payment: false,
                };
                break;
            case 'GET_STATUS_FAILURE':
                state.status_loading = false;
                state.status_error = true;
                state.status = {
                    devplan_status: false,
                    consumption_status: false,
                    payment: false,
                };
                break;
            default:
                break;
        }
    });
}
export default appDevPlanStatusReducer;
